import React from 'react';
import { Form } from 'react-bootstrap';
import Button from '../../components/Button/Button';
import { FaStar } from 'react-icons/fa';
import Switch from '../../components/Switch/Switch';
import Loader from '../../components/Loader/Loader';
import './TraitForm.css';

const TraitForm = ({ onSubmit, onChange, onInputChange, onSwitchChange,
  name, programIds, programData, loader }) => {

  return (
    <Form onSubmit={onSubmit}>
      {loader && <div className="loader"><Loader /></div>}
      <div className="row">
        <div className="col-md-6 mb-3">
          <Form.Group>
            <Form.Label>
              Trait Name<i className="text-danger">*</i>
            </Form.Label>
            <Form.Control
              type="text"
              name="name"
              id="name"
              onChange={onChange}
              placeholder="Enter Program name"
              value={name}
              required
            />
          </Form.Group>
        </div>
        <div className="col-md-12">
          <Form.Label className="d-flex align-items-center gap-2">
            <FaStar />
            <span>Available for classes</span>
          </Form.Label>
          <div className="trait-panel">
            <div className="trait-select-all-row">
              <Switch
                checked={programIds.length === programData.length}
                value="1"
                name="all"
                onChange={onSwitchChange}
                id="select-all"
                label="Select All"
              />
              <span className="small text-muted">{programIds.length} of {programData.length} selected</span>
            </div>
            <div className="trait-class-grid">
              {programData && programData.map((program, idx) => (
                <div className="trait-class-item" key={idx}>
                  <Switch
                    name="program_ids"
                    id={program.id}
                    checked={programIds.includes(program.id.toString())}
                    value={program.id}
                    onChange={onInputChange}
                    label={program.name}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="col-md-12 d-flex justify-content-end">
          <div className="mt-3">
            <Button variant="success" type="submit">
              Submit
            </Button>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default TraitForm;
